import { render, staticRenderFns } from "./MetricPath.vue?vue&type=template&id=159b048a&scoped=true"
import script from "./MetricPath.vue?vue&type=script&lang=js"
export * from "./MetricPath.vue?vue&type=script&lang=js"
import style0 from "./MetricPath.vue?vue&type=style&index=0&id=159b048a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b048a",
  null
  
)

export default component.exports